interface ClassNameMap {
	[index: number]: { className: string };
}

/**
 * Enum for sidebar position
 */
enum SidebarPosition {
	LEFT = 'left',
	RIGHT = 'right',
}

/**
 * SidebarLayout component props
 */
interface SidebarLayoutProps {
	/** Content for the sidebar */
	sidebar: React.ReactNode;
	/** Main content of the layout */
	main: React.ReactNode;
	/** Class name for the container div */
	containerClassName?: string;
	/** Class name for the sidebar div */
	sidebarClassName?: string;
	/** Class name for the content div */
	contentClassName?: string;
	/** Position of the sidebar */
	sidebarPosition?: SidebarPosition;
	/** ARIA label for the sidebar */
	sidebarAriaLabel?: string;
	/** ARIA label for the main content */
	contentAriaLabel?: string;
	/** Whether the sidebar should be displayed */
	isSidebarOpen?: boolean;
}
export type { ClassNameMap, SidebarLayoutProps };
export { SidebarPosition };
